import React from 'react';
import { Checkbox } from '@/components/ui/checkbox';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { PLATFORMS } from '@/lib/clipPlatformFormats';
import { PUBLISHING_STATUSES } from '@/lib/scheduleData';

const CONTENT_KINDS = [['video', 'Long-form Videos'], ['clip', 'Clips'], ['design', 'Images & Posts']];

/**
 * Schedule → Filters (section 4/10): creator/project scope plus
 * platform, asset-type and status filters for what the calendar shows.
 * Purely a view filter — never deletes or hides data permanently.
 */
export function ScheduleFiltersPanel({ scope, onScopeChange, canUseCreatorScope, platformFilter, onTogglePlatform, statusFilter, onToggleStatus, kindFilter, onToggleKind }) {
  return (
    <div className="space-y-4" data-testid="schedule-filters-panel">
      <div>
        <p className="text-[11px] uppercase tracking-wide text-[#555E6E] mb-1.5">Calendar Scope</p>
        <RadioGroup value={scope} onValueChange={onScopeChange} className="space-y-1.5">
          <label className="flex items-center gap-2 text-xs text-white cursor-pointer"><RadioGroupItem value="project" data-testid="schedule-filter-scope-project" />Current Project</label>
          <label className={`flex items-center gap-2 text-xs cursor-pointer ${canUseCreatorScope ? 'text-white' : 'text-[#555E6E]'}`}><RadioGroupItem value="creator" disabled={!canUseCreatorScope} data-testid="schedule-filter-scope-creator" />Entire Creator Calendar</label>
        </RadioGroup>
        {!canUseCreatorScope && <p className="text-[10px] text-[#555E6E] mt-1">No creator selected — open Schedule from a project to enable this.</p>}
      </div>

      <div>
        <p className="text-[11px] uppercase tracking-wide text-[#555E6E] mb-1.5">Platform</p>
        <div className="space-y-1">
          {PLATFORMS.map((p) => (
            <label key={p.key} className="flex items-center gap-2 text-xs text-white cursor-pointer" data-testid={`schedule-filter-platform-${p.key}`}>
              <Checkbox checked={platformFilter.has(p.key)} onCheckedChange={() => onTogglePlatform(p.key)} />{p.label}
            </label>
          ))}
        </div>
      </div>

      <div>
        <p className="text-[11px] uppercase tracking-wide text-[#555E6E] mb-1.5">Asset Type</p>
        <div className="space-y-1">
          {CONTENT_KINDS.map(([key, label]) => (
            <label key={key} className="flex items-center gap-2 text-xs text-white cursor-pointer" data-testid={`schedule-filter-kind-${key}`}>
              <Checkbox checked={kindFilter.has(key)} onCheckedChange={() => onToggleKind(key)} />{label}
            </label>
          ))}
        </div>
      </div>

      <div>
        <p className="text-[11px] uppercase tracking-wide text-[#555E6E] mb-1.5">Status</p>
        <div className="space-y-1">
          {PUBLISHING_STATUSES.filter((s) => s !== 'draft' && s !== 'ready').map((s) => (
            <label key={s} className="flex items-center gap-2 text-xs text-white capitalize cursor-pointer" data-testid={`schedule-filter-status-${s}`}>
              <Checkbox checked={statusFilter.has(s)} onCheckedChange={() => onToggleStatus(s)} />{s}
            </label>
          ))}
        </div>
      </div>
    </div>
  );
}
